export var NsTreePanelData;
(function (NsTreePanelData) {
    NsTreePanelData.id = 'TREE_PANEL_DATA';
})(NsTreePanelData || (NsTreePanelData = {}));
//# sourceMappingURL=interface.js.map